import { useEffect, useState } from "react";
import api from "@/lib/api";

function initials(name = "") {
  return name.split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]?.toUpperCase()).join("") || "?";
}

export function Avatar({ userId, hasPhoto, updatedAt, name, size = 40, testid }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let objectUrl = null;
    let active = true;
    if (hasPhoto && userId) {
      api.get(`/profile/photo/${userId}`, { responseType: "blob" })
        .then((r) => {
          if (!active) return;
          objectUrl = URL.createObjectURL(r.data);
          setUrl(objectUrl);
        })
        .catch(() => active && setUrl(null));
    } else {
      setUrl(null);
    }
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [userId, hasPhoto, updatedAt]);

  const style = { width: size, height: size };
  if (url) {
    return <img src={url} alt={name} data-testid={testid} className="object-cover border border-border" style={style} />;
  }
  return (
    <div data-testid={testid} className="bg-primary text-primary-foreground flex items-center justify-center font-display font-bold border border-border" style={{ ...style, fontSize: size * 0.4 }}>
      {initials(name)}
    </div>
  );
}
